const header = "_uxsh9f592l";
const heading = "_uxsh1xl2d0j";
const backlink = "_uxsb144585a";

export { backlink, header, heading };
import "./organism.print.style.linaria.module.css";
//# sourceMappingURL=organism.print.style.js.map
